let seoConfig = {
  seo_title: '',
  seo_keywords: '',
  seo_description: ''
}

function setMeta(name, content) {
  if (!content) return
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export function applyMetaTags() {
  setMeta('keywords', seoConfig.seo_keywords)
  setMeta('description', seoConfig.seo_description)
}

export function setSeoConfig(config = {}) {
  seoConfig = {
    seo_title: config.seo_title || '',
    seo_keywords: config.seo_keywords || '',
    seo_description: config.seo_description || ''
  }
  applyMetaTags()
}

export function getDefaultTitle() {
  return seoConfig.seo_title || '谱仪通'
}

export function getSiteName() {
  const title = getDefaultTitle()
  const idx = title.indexOf(' - ')
  return idx > -1 ? title.slice(0, idx) : title
}

export function setPageTitle(pageTitle) {
  if (pageTitle) {
    document.title = `${pageTitle} - ${getSiteName()}`
  } else {
    document.title = getDefaultTitle()
  }
  applyMetaTags()
}

import { setContactInfo } from './contact'

export async function initSeo(fetchContactInfo) {
  try {
    const info = await fetchContactInfo()
    setContactInfo(info || {})
    setSeoConfig(info || {})
  } catch (e) {
    setContactInfo({})
    setSeoConfig({})
  }
}
